import { useQuery } from '@apollo/client';

import { useDegreeContext } from 'bundles/degree-home/components/v2/DegreeHomeContext';
import type {
  UseCourseOfferingsQuery as UseCourseOfferingsQueryData,
  UseCourseOfferingsQueryVariables,
} from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/useCourseOfferings';
import UseCourseOfferingsQuery from 'bundles/degree-home/components/v3-dpm/lib/__queries__/useCourseOfferings.graphql';

const useCourseOfferings = (estimatedTermId: string) => {
  const { degreeId } = useDegreeContext();
  const variables: UseCourseOfferingsQueryVariables = {
    degreeId,
    termMappingId: estimatedTermId,
    limit: 100,
  };

  return useQuery<UseCourseOfferingsQueryData, UseCourseOfferingsQueryVariables>(UseCourseOfferingsQuery, {
    variables,
    context: { clientName: 'gatewayGql' },
  });
};

export default useCourseOfferings;
